'use client';

import cn from 'classnames';
import { useState, useMemo } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from 'react-responsive';

import type { Locale } from '@shared/libs';
import { ImageWithFallback, ButtonExpand, ButtonExpandType, unbounded } from '@shared/ui';

import type { TVideoItem } from '../../model';
import styles from './variants.module.css';

type TProps = {
  locale: Locale;
  variants: TVideoItem[];
  setActiveItem: Dispatch<SetStateAction<TVideoItem | null>>;
  activeItem: TVideoItem | null;
};

export const Variants = ({ locale, variants, setActiveItem, activeItem }: TProps) => {
  const [open, setOpen] = useState(false);
  const isTablet = useMediaQuery({ maxWidth: 768 });

  const sortedData = useMemo(() => variants.sort((a) => (a.ready ? -1 : 1)), [variants]);

  return (
    <div className={styles.card}>
      <div
        className={cn(styles.content, {
          [styles.contentClose]: !open,
        })}
      >
        <p className={cn(styles.title, unbounded.className)}>
          {locale.AI_PLAYER_VARIANTS || 'AI_PLAYER_VARIANTS'}
        </p>

        <div>
          {sortedData.map((item) => {
            const { id, title, subTitle, thumb, ready } = item;
            return (
              // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
              <div
                className={cn(styles.values, {
                  [styles.active]: activeItem?.id === id,
                })}
                key={id}
                onClick={() => {
                  setActiveItem(item);
                  if (isTablet) {
                    document?.getElementById('ai-player')?.scrollIntoView();
                  }
                }}
              >
                <div className={styles.previewWrap}>
                  {ready && <div className={styles.label_ready} />}
                  {/* {validate && <div className={styles.label_validate} />} */}

                  <ImageWithFallback 
                    className={styles.preview} 
                    width={80} 
                    height={48} 
                    alt="alt" 
                    src={thumb}
                    fallbackText="Превью недоступно" 
                  />
                </div>
                <div>
                  <p className={styles.title}>{title}</p>
                  <p className={styles.subTitle}>{subTitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <ButtonExpand
        type={open ? ButtonExpandType.CLOSE : ButtonExpandType.OPEN}
        className={open ? undefined : styles.iconClose}
        onClick={() => setOpen((val) => !val)}
      />
    </div>
  );
};
